import script from "./DownloadAppButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadAppButton.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadAppButton.vue?vue&type=style&index=0&id=7e9834e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9834e9"]])

export default __exports__